import React from 'react';
import { DmsAltBox, DmsBarChart, intl } from 'dmsbasereact';
import { Typography, Box } from '@mui/material';

export const InsightsChart = ({ chartDatasets, chartLabels, chartOptions }) => {
    const hasData = chartLabels && chartLabels.length > 0;

    return (
        <DmsAltBox.Card sx={{ height: '100%' }}>
            <DmsAltBox.Header>
                <Typography variant="h6">
                    {intl
                        .get("DispensationInsights.Chart.Title")
                        .d("Dispensed Boxes Quantity and Dispensed Strength Over Time")}
                </Typography>
            </DmsAltBox.Header>
            <DmsAltBox.Body>
                <Box sx={{ height: 350, width: '100%', position: 'relative' }}>
                    {hasData ? (
                        <DmsBarChart
                            datasets={chartDatasets}
                            labels={chartLabels}
                            options={chartOptions}
                        />
                    ) : (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%'
                            }}
                        >
                            <Typography color="text.secondary">
                                {intl
                                    .get("DispensationInsights.Chart.NoData")
                                    .d("No data available for the selected period")}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </DmsAltBox.Body>
        </DmsAltBox.Card>
    );
};
